module.exports = __webpack_public_path__ + "img/treatments-directory-card-desktop-ru.4664bcaf.jpg";